import "./App.css";
import React, { useEffect, useContext, useState, createContext } from "react";
import { Routes, Route, Link, Navigate } from "react-router-dom";
import { LoadingBarContainer, useLoadingBar } from "react-top-loading-bar";

import Signup from "./pages/auth/Signup";
import Login from "./pages/auth/Login";
import Users from "./pages/auth/Users";
//new
import UserLayout from "./layouts/UserLayout";
import Profile from "./pages/user/Profile";
import Homepage from "./pages/HomePage";
import DContext from "./context/DContext";
import Faq from "./pages/user/Faq";
import Demopage from "./pages/Demopage";
import toast, { ToastBar, Toaster } from "react-hot-toast";
import AuthLayout from "./layouts/AuthLayout";
import Inventory from "./pages/inventory/Inventory";
import Vendor from "./pages/vendor/Vendor";
import Agent from "./pages/agent/Agent";
import Supplier from "./pages/supplier/Supplier";
import Notifications from "./pages/user/Notifications";
import Flight from "./pages/flight/Flight";
import Location from "./pages/location/Location";
import ForgotPassword from "./components/auth/ForgotPassword";
import Wallet from "./pages/wallet/Wallet";
import WalletTopup from "./components/wallet/WalletTopup";
import Airlines from "./pages/airlines/Airlines";
import Airports from "./pages/airports/Airports";
import Setting from "./pages/setting/Setting";
import Logs from "./pages/logs/Logs";
import FlightSearch from "./pages/flight-search/FlightSearch";
import RbacMenu from "./pages/rbac/menus/RbacMenu";
import RbacRoleModuleAccess from "./pages/rbac/role-module-access/RbacRoleModuleAccess";
import RbacRoleList from "./components/rbac/roles/RbacRoleList";
import RbacModuleList from "./components/rbac/modules/RbacModuleList";
import RbacMenuList from "./components/rbac/menu/RbacMenuList";
import RbacRoleModuleAccessList from "./components/rbac/role-module-access/RbacRoleModuleAccessList";

const App = () => {
  const { authState, authDispatch, login, logout } = useContext(DContext);

  const { user, ustate, isLoggedIn, authLoading } = authState;

  useEffect(() => {
    //toast('Here is your toast.');
    //toast.success('Here is your toast.');
    //toast.loading('Here is your toast.');
    //toast.error('Here is your toast.');
    //toast.custom('Here is your toast.');
  }, []);

  const demoFun = () => {
    console.log("demo fun runs");
    // authDispatch({ type: "AUTH_ERROR", payload: "Message changed" });
    // authDispatch({ type: "LOGIN", payload: "Message changed" });
  };

  return (
    <>
      <LoadingBarContainer>
        <Toaster />
        {/* {ustate}
        <button onClick={demoFun}>click</button> */}

        {authLoading ? null : !isLoggedIn ? (
          <>
            <Routes>
              <Route path="/signup" element={<Signup />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </>
        ) : (
          <>
            <Routes>
              <Route path="/" element={<UserLayout />}>
                <Route path="" element={<Homepage />} />
                <Route path="profile" element={<Profile />} />
                <Route path="notifications" element={<Notifications />} />
                <Route path="wallet" element={<Wallet />} />
                <Route path="wallet/wallet-topup" element={<WalletTopup />} />
                <Route path="faq" element={<Faq />} />
                <Route path="inventory/:method" element={<Inventory />} />
                <Route path="suppliers/:method" element={<Supplier />} />
                <Route path="vendor/:method" element={<Vendor />} />
                <Route path="agency/:method" element={<Agent />} />
                <Route path="flight/:method" element={<Flight />} />
                <Route path="flight-search" element={<FlightSearch />} />
                <Route path="location/:method" element={<Location />} />
                <Route path="airlines-details" element={<Airlines />} />
                <Route path="airports-details" element={<Airports />} />
                <Route path="setting" element={<Setting />} />
                <Route path="logs" element={<Logs />} />
                <Route path="logs/:method" element={<Logs />} />
                <Route path="logs/:method/:id" element={<Logs />} />
                <Route path="rbac-menu" element={<RbacMenu />} />
                <Route path="rbac/modules" element={<RbacModuleList />} />
                <Route path="rbac/roles" element={<RbacRoleList />} />
                <Route path="rbac/menus" element={<RbacMenuList />} />
                <Route
                  path="rbac/role-module-access"
                  element={<RbacRoleModuleAccessList />}
                />
                <Route
                  path="rbac-role-module-access"
                  element={<RbacRoleModuleAccess />}
                />

                <Route path="demo/:demoid" element={<Demopage />} />

                {/* if no route is defined then replace it to blank means with homepage route */}
                <Route path="*" element={<Navigate to="" replace />} />
              </Route>
            </Routes>
          </>
        )}
      </LoadingBarContainer>
    </>
  );
};

export default App;
